module.exports = __webpack_public_path__ + "static/media/ic_gift.56e97054.svg";